/** Checkout route for plan upgrade from Campaign Chat. */
export const CAMPAIGN_CHECKOUT_ROUTE = '/PlanCheckoutUser';
